import React from 'react';
import VendorTopLogin from "./VendorTopLogin";
import IntroducingSayman from "./IntroducintSayman";
import WorkStartProcess from "./WorkStartProcess";
import VendorSlider from "./VendorSlider";
import Questions from "./Questions";
import Footer from "../../footer/Footer";
import VendorLoginSellers from "./VendorLoginSellers";

const VendorHomePage = () => {
    return (
        <div className="vendor-home-page-wrapper">
            <VendorTopLogin/>
            <IntroducingSayman/>
            <WorkStartProcess/>
            <VendorSlider/>
            <Questions/>
            <VendorLoginSellers/>
            <Footer/>
        </div>
    );
};

export default VendorHomePage;
